import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import Cart from '../customer_pages/_cart/cart';

import '../customer_pages/_cart/cart-omni-analytics';
import '../customer_pages/_cart/cart-google-tag-manager';
import '../customer_pages/_libs/analytics/checkout-google-analytics.js';
import '../customer_pages/_cart/added-to-cart-omni-analytics';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('content');

  const props = JSON.parse(root.dataset.props);

  hydrateRoot(root, <Cart {...props} />);
});
